import React from "react";
import useSmartviewManager from "./use-smartview-manager";

export default function useOnSmartviewClickOutside(callback) {
    const manager = useSmartviewManager();

    React.useEffect(() => {

        if(typeof callback !== 'function') {
            return;
        }

        const disposer = manager.onClickOutside(() => {
            callback();
        });

        return () => {
            disposer();
        }
    }, []);

}
